import axios from "axios";
import _ from "underscore";
import * as actionTypes from "./types";
//import searchAnswerMock from "./answer";

export const clearDataAndSearch = () => (dispatch, getState) => {
  dispatch(setDisplaySpinner(true));
  dispatch(clearData());
  dispatch(search(dispatch, getState));
};

export const search = () => (dispatch, getState) => {
  dispatch(setDisplaySpinner(true));
  const searchCriterias = getSearchCriterias(dispatch, getState);
  axios
    .post("/api/pages/search", searchCriterias)
    .then(result => {
      if (result.status === 200 && result.data) {
        dispatch(
          setSearchResult(result.data, getState().files.allSpecifications)
        );
      } else {
        dispatch(setErrorPage(result));
      }
      dispatch(setDisplaySpinner(false));
    })
    .catch(error => {
      console.log("error");
      console.log(error);
    });
};

const getSearchCriterias = (dispatch, getState) => {
  if (!getState().searchData.allDates) {
    dispatch(getReleventFiles(getState));
  }
  const seledctedAggregations = getSelectedAggregationsData(getState);
  return {
    term: getState().searchData.searchTerm,
    fromDate: getState().searchData.date,
    //size: 1000,
    relevantDocs: getState().searchData.relevantFiles,
    seledctedAggregations: seledctedAggregations
  };
};

const getSelectedAggregationsData = getState => {
  const checkedAggs = _.filter(getState().searchData.aggregations, "checked");

  const toReturn = _.map(checkedAggs, agg => {
    //let by = "chapterRefiner";
    //if (agg.chapterId && agg.chapterId !== "") {
    ///ITS NOT CHAPTER
    //  by = "docRefiner";
    //}
    return { aggBy: "chapterRefiner", value: agg.aggregationText };
  });
  return toReturn;
};

const getReleventFiles = getState => {
  return {
    type: actionTypes.SET_RELEVENT_FILES,
    payload: getState().files.allSpecifications
  };
};

const clearData = () => {
  return {
    type: actionTypes.CLEAR_DATA
  };
};

const setSearchResult = (searchResult, allSpecifications) => {
  return {
    type: actionTypes.SET_SEARCH_RESULTS,
    payload: {
      result: searchResult,
      allSpecifications: allSpecifications
    }
  };
};

export const setErrorPage = result => {
  return { type: actionTypes.SET_ERROR_MESSAGE };
};
export const setDisplaySpinner = value => dispatch => {
  dispatch(set(actionTypes.SET_DISPLAY_SPINNER, value));
};
export const setTerm = value => dispatch => {
  dispatch(set(actionTypes.SET_TERM, value));
};
export const setDate = value => dispatch => {
  value.setHours(4); //avoid date cahnge due to time zone issue
  const datePayload = {
    date: value,
    allDates: false
  };
  dispatch(set(actionTypes.SET_DATE, datePayload));
};
export const setAllDates = value => dispatch => {
  const allDatesPayload = {
    date: value ? null : new Date(),
    allDates: value
  };
  dispatch(set(actionTypes.SET_ALL_DATES, allDatesPayload));
};
export const set = (actionType, value) => {
  return { type: actionType, payload: value };
};
export const resultsSort = displayByChapter => {
  return { type: actionTypes.DISPLAY_BY_CHAPTER, payload: displayByChapter };
};

export const aggregationClicked = (id, isChecked) => dispatch => {
  dispatch(selectAggregation(id, isChecked));
  dispatch(search());
};

export const checkAllAggregations = isCheced => dispatch => {
  dispatch(selectAllAggregations(isCheced));
  dispatch(search());
};

const selectAggregation = (id, isChecked) => {
  return {
    type: actionTypes.SELECT_AGGREGATION,
    payload: {
      id: id,
      isChecked: isChecked
    }
  };
};

const selectAllAggregations = isChecked => {
  return { type: actionTypes.SELECT_ALL_AGGREGATIONS, payload: isChecked };
};
